<template>
  <div v-if="load">
    <v-skeleton-loader type="article"></v-skeleton-loader>
  </div>
  <div v-else>
    <div v-if="showContent">
      <v-data-table :headers="headers" :items="documents" :hide-default-footer="true" :items-per-page="-1">
        <template v-slot:item="{ item }">
          <tr>
            <td>
              <a :href="$model.wwwroot + '/blocks/manage_groups/documents/newDocument.php?id=' + item.id"
                target="_blank">Открыть</a><br />
              <a :href="$model.wwwroot + '/blocks/manage_groups/documents/newDocument.php?action=print&id=' + item.id"
                target="_blank">Печать</a>
            </td>
            <td>{{ item.author }}</td>
            <td>{{ item.sender }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.ordernum }} от {{ item.orderdate }}</td>
            <td>{{ item.state }}</td>
            <td>{{ item.next_user }}</td>
            <td>{{ item.date_change }}</td>
          </tr>
        </template>
        <template v-slot:bottom> </template>
      </v-data-table>
    </div>
    <div v-else class="cursor-pointer">
      <v-col class="d-flex flex-column align-center">
        <v-icon color="info" icon="mdi-message-text"></v-icon>
      </v-col>

      <v-col style="word-break: break-all" class="d-flex flex-column align-center">
        <span>Входящие ({{ documents.length }})</span>
      </v-col>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    //поле data из psm_desktop_widgets
    data: {
      required: true,
    },
    showContent: {
      default: false,
      type: Boolean
    }
  },
  name: "incomingWidget",
  data() {
    return {
      load: false,
      headers: [
        {
          title: "Действие",
          align: "center",
          sortable: false,
        },
        {
          title: "Автор",
          align: "center",
          sortable: false,
        },
        {
          title: "Отправил",
          align: "center",
          sortable: false,
        },
        {
          title: "Тип документа",
          align: "center",
          sortable: false,
        },
        {
          title: "Номер",
          align: "center",
          sortable: false,
        },
        {
          title: "Статус",
          align: "center",
          sortable: false,
        },
        {
          title: "Ответственный",
          align: "center",
          sortable: false,
        },
        {
          title: "Дата последнего изменения",
          align: "center",
          sortable: false,
        },
      ],
      documents: []
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.load = true;
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/psm_desktop2/widgets/incoming/get"
        )
        .then((response) => {
          this.documents = response.data;
          this.load = false;
        })
        .catch((error) => {
          this.load = false;
          console.log(error);
        });
    }
  },
};
</script>
<style lang="scss"></style>
